import "./StoresTableModal.scss";
import secondaryComponents from "..";
import primaryComponents from "../../primaryComponents";
import StoresTableModalValidation from "./StoresTableModalValidation";
import StoresTableModalLogic from "./StoresTableModalLogic";
import { Controller } from "react-hook-form";
import { useEffect } from "react";

const StoresTableModal = ({ isActive, setIsActive, handleFetchStores }) => {
  const {
    storeName,
    storeAddress,
    settlementAccount,
    storeCategory,
    isLoading,
    vat,
    isWarehouse,
    setVat,
    setStoreName,
    setStoreAddress,
    setSettlementAccount,
    handleAddStore,
    business_list,
    category_list,
    setIsWarehouse,
    setStoreCategory,
  } = StoresTableModalLogic({ setIsActive, handleFetchStores });

  const {
    register,
    formState: { errors },
    trigger,
    control,
    handleSubmit,
    setError,
    clearErrors,
    reset,
  } = StoresTableModalValidation({
    storeName,
    storeAddress,
    settlementAccount,
    isWarehouse,
    storeCategory,
  });

  useEffect(() => {
    window.setNewStoreError = setError;
    window.clearNewStoreError = clearErrors;
    window.resetNewStoreForm = reset;
  }, []);

  return (
    <secondaryComponents.Modal
      isActive={isActive}
      width="600px"
      closeModal={() => setIsActive(false)}
      style={{ marginTop: "30px" }}
    >
      <div className="stores-table-modal">
        <h4 className="text-center font-weight-semibold">Add new store</h4>
        <form
          className="stores-table-modal__form"
          style={{ marginTop: "32px" }}
          onSubmit={handleSubmit(handleAddStore)}
        >
          {/* Store Name */}
          <Controller
            name="storeName"
            control={control}
            defaultValue={storeName}
            render={({ field: { onChange } }) => (
              <primaryComponents.InputField
                label="Store Name"
                placeholder="Enter your store name"
                isRequired={true}
                type="text"
                name="storeName"
                errorMessage={errors.storeName}
                onKeyUp={() =>
                  errors.storeName !== undefined && trigger("storeName")
                }
                onChange={({ target: { value } }) => {
                  onChange(value);
                  setStoreName(value);
                }}
                register={register}
              />
            )}
          />
          {/* Store Address */}
          <Controller
            name="storeAddress"
            control={control}
            defaultValue={storeAddress}
            render={({ field: { onChange } }) => (
              <primaryComponents.InputField
                label="Store Address"
                placeholder="Enter your store street address"
                isRequired={true}
                type="text"
                name="storeAddress"
                errorMessage={errors.storeAddress}
                onKeyUp={() =>
                  errors.storeAddress !== undefined && trigger("storeAddress")
                }
                onChange={({ target: { value } }) => {
                  onChange(value);
                  setStoreAddress(value);
                }}
                register={register}
              />
            )}
          />
          {/* Settlement account */}
          <Controller
            name="settlementAccount"
            control={control}
            defaultValue={settlementAccount}
            render={({ field: { onChange } }) => (
              <primaryComponents.SelectField
                label="Select Business"
                placeholder="Select business"
                isRequired={true}
                value={settlementAccount || "Select business"}
                options={business_list}
                nameKey="tag"
                idKey="id"
                errorMessage={errors.settlementAccount}
                onChange={(value) => {
                  onChange(value);
                  setSettlementAccount(value);
                }}
              />
            )}
          />
          {/* Store category */}
          <Controller
            name="storeCategory"
            control={control}
            defaultValue={storeCategory}
            render={({ field: { onChange } }) => (
              <primaryComponents.SelectField
                label="Select Category"
                placeholder="Select category"
                isRequired={true}
                value={storeCategory || "Select category"}
                options={category_list}
                nameKey="name"
                idKey="id"
                errorMessage={errors.storeCategory}
                onChange={(value) => {
                  onChange(value);
                  setStoreCategory(value);
                }}
              />
            )}
          />
          {/* vat */}
          <Controller
            name="vat"
            control={control}
            defaultValue={vat}
            render={({ field: { onChange } }) => (
              <primaryComponents.InputField
                name="vat"
                value={vat}
                label="VAT Rate(%)"
                placeholder="Enter VAT Rate"
                onChange={({ target: { value } }) => {
                  onChange(value);
                  setVat(value);
                }}
                type="number"
                min="0"
                max="100"
                step="0.01"
                errorMessage={errors.vat}
                onKeyUp={() => errors.vat !== undefined && trigger("vat")}
                register={register}
              />
            )}
          />

          <Controller
            name="isWarehouse"
            control={control}
            render={({ field: { onChange } }) => (
              <primaryComponents.SelectField
                name="is_warehouse"
                label="Do you want this store to serve as a warehouse?"
                nameKey="label"
                idKey="value"
                isRequired={true}
                value={isWarehouse === false ? "No" : isWarehouse}
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                onChange={(value) => {
                  onChange(value);
                  setIsWarehouse(value);
                }}
                errorMessage={errors?.isWarehouse}
              />
            )}
          />

          <div
            className="d-flex align-items-center justify-content-between"
            style={{ marginTop: "32px" }}
          >
            <primaryComponents.Button
              classNames={"btn btn--outline"}
              onClick={() => setIsActive(false)}
            >
              Cancel
            </primaryComponents.Button>
            <primaryComponents.Button
              className={"btn  btn--primary"}
              isLoading={isLoading}
              loadingText="Adding Store..."
              isDisabled={
                errors.storeAddress ||
                errors.storeName ||
                errors.settlementAccount ||
                errors.isWarehouse ||
                isLoading
              }
            >
              Add new store
            </primaryComponents.Button>
          </div>
        </form>
      </div>
    </secondaryComponents.Modal>
  );
};

export default StoresTableModal;
